export default {
    DASHBOARD: {
        path: '/dashboard',
        name: 'dashboard'
    },
    MANAGE_FONTS: {
        path: '/manage-fonts',
        name: 'home'
    },
    PROMOTION: {
        path: '/promos',
        name: 'promos'
    },
    EARNINGS_REPORT: {
        path: '/earnings-report',
        name: 'earnings_report_dashboard'
    },
    PAYMENTS: {
        path: '/payments',
        name: 'payment_dashboard'
    },
    PAYMENT_ACCOUNT: {
        path: '/payment-accounts',
        name: 'payment_accounts'
    },
    AGGREMENTS: {
        path: '/agreements',
        name: 'contract'
    },
    FOUNDRY_PROFILE: {
        path: '/foundry-profile',
        name: 'foundry_profile'
    },
    USER_PERMISSIONS: {
        path: '/user-permissions',
        name: 'user_permissions'
    },
    APPLICATIONS: {
        path: '/applications',
        name: 'application'
    },
    BUNDLE: {
        path: '/bundle-dashboard',
        name: 'BundleDashboard'
    },
    IMPERSONATE: {
        path: '/impersonate',
        name: 'impersonate'
    },
    INVENTORY_INGESTION_HUB: {
        path: '/inventory-hub',
        name: 'InventoryIngestionHub'
    },
    MFP_NUMBERS: {
        path: '/mfp-numbers',
        name: 'mfp-numbers'
    },
    DROPSHIP: {
        path: '/dropship',
        name: 'DropShip'
    },
    QUARTERLY_EARNINGS_UPLOAD: {
        path: '/quarterly-earnings-upload',
        name: 'quarterly-earnings-upload'
    },
    REACTIVATE_FONT_FAMILIES: {
        path: '/reactivate-font-families',
        name: 'reactivate_font_families'
    },
    ARTICLES: {
        path: 'https://fontplatform.monotype.com/content/resources/educational-article',
        name: 'articles'
    },
    EVENTS: {
        path: 'https://fontplatform.monotype.com/content/resources/events',
        name: 'events'
    },
    VIDEOS: {
        path: 'https://fontplatform.monotype.com/content/resources/videos',
        name: 'videos'
    },
    TEAMS: {
        path: 'https://fontplatform.monotype.com/content/team',
        name: 'teams'
    },
    NON_UFDA2: {
        articles: {
            path: '/non-ufda2/articles',
            name: 'non-ufda2-articles'
        },
        events: {
            path: '/non-ufda2/events',
            name: 'non-ufda2-events'
        },
        videos: {
            path: '/non-ufda2/videos',
            name: 'non-ufda2-videos'
        }
    }
}
